import { useField, ErrorMessageProps } from 'formik'
import { MenuItem, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Select, InputLabel, Placeholder } from './AdjustableSelect.style'
import { Option } from 'shared/types'

interface FormikTextfieldProps {
  parentError?: ErrorMessageProps
  options: Option[]
  name: string
  label?: string | JSX.Element | (string | JSX.Element)[]
  placeholder?: string
  onChange?: (value: string | number) => any
  fullWidth?: boolean
  disabled?: boolean
  labelSize?: number
  labelComponent?: typeof InputLabel
  blurAfterChange?: boolean
}

const AdjustableSelect = (props: FormikTextfieldProps) => {
  const { options = [], name, parentError, onChange, labelComponent } = props
  const [field, meta] = useField(name)

  const LabelComponent = labelComponent || InputLabel

  return (
    <>
      <LabelComponent labelSize={props.labelSize} disabled={props.disabled}>
        {props.label}
      </LabelComponent>
      <Select
        {...props}
        error={!!parentError || !!meta.error}
        MenuProps={{
          disablePortal: true,
          getContentAnchorEl: null,
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
          transformOrigin: { vertical: 'top', horizontal: 'center' },
        }}
        variant="outlined"
        required={false}
        {...field}
        onChange={e => {
          field.onChange(e)

          if (onChange) {
            onChange(e.target.value as string | number)
          }

          if (props.blurAfterChange) {
            setTimeout(() => {
              ;(document.activeElement as any)?.blur()
            })
          }
        }}
        renderValue={value =>
          value ? (
            <Typography>
              {options.find(option => option.value === value)?.title}
            </Typography>
          ) : (
            <Placeholder>{props.placeholder}</Placeholder>
          )
        }
        IconComponent={ExpandMoreIcon}
        displayEmpty
      >
        {options.map(({ title, value }) => (
          <MenuItem key={value} value={value}>
            {title}
          </MenuItem>
        ))}
      </Select>
    </>
  )
}

export default AdjustableSelect
